import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDispatch} from 'react-redux';
import Command from '../../../state/actions/command';
import {WorkingTime} from '../../../state/types/WorkingTime';

interface DeleteWorkingTimeDialogProps {
    open: boolean;
    onClose: () => void;
    workingTime?: WorkingTime;
}

const DeleteWorkingTimeDialog = (props: DeleteWorkingTimeDialogProps) => {
    const dispatch = useDispatch();

    if (!props.workingTime) {
        return null;
    }

    const handleDelete = () => {
        dispatch(Command.WorkingTime.deleteWorkingTime({
            workingTimeId: props.workingTime!.workingTimeId,
            projectId: props.workingTime!.projectId,
            start: props.workingTime!.start,
            end: props.workingTime!.end,
        }));
        props.onClose();
    };

    return (
        <Dialog open={props.open} fullWidth={true} onClose={props.onClose}>
            <DialogTitle>Arbeitszeit löschen</DialogTitle>
            <DialogContent>
                <Typography>
                    Sind Sie sicher, dass Sie diesen Zeiteintrag löschen wollen?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>
                    Abbrechen
                </Button>
                <Button
                    variant={'contained'}
                    color={'error'}
                    startIcon={<DeleteIcon />}
                    onClick={handleDelete}
                >
                    Löschen
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteWorkingTimeDialog;
